const axios = require('axios');

if(document.getElementById('documentation')) {

    const dataUrl = process.env.MIX_API_URL_PROD;
    const selectDepartement = document.getElementById('select-departement')

    axios.get(dataUrl + '/departements')
    .then(function (response) {
        const departements = response.data;
        departements.forEach(departement => {

            let departementName = departement.nom;
            let departementId = departement.id;
            let departementNumber = departement.numero;
            let option = document.createElement('option');

            option.value = departementId;
            option.textContent = departementNumber + ' ' + departementName;
            selectDepartement.appendChild(option);
        });

    })



    function formSubmit ()  {
        const form = document.querySelector('form');
        const formData = new FormData(form);
        grecaptcha.ready(function() {
            grecaptcha.execute(form.dataset.captchakey, {action: 'documentation_request'}).then(function(token) {

                formData.append('captcha', token);
                formData.append('action', 'documentation_request');

                let spinner = document.querySelector('.spinner-loading');
                let submitButton = document.querySelector('.btn2');

                submitButton.disabled = true;
                spinner.classList.remove('hidden');
                axios.post('documentation-request', formData)
                .then(response => {
                    spinner.classList.add('hidden');
                    submitButton.disabled = false;
                    document.querySelector('.alert-text').innerHTML = '';

                    if(response.data.message === 'success'){
                        window.location.href = "https://www.le-kiosque-a-pizzas.com/rejoignez-nous/demande-documentation/demande-envoyee";
                    }else {
                        console.log(response.data);

                        if(response.data.message && response.data.message === 'error'){
                            document.querySelector('.alert-wrapper').classList.remove('hidden');
                            document.querySelector('.alert-text').innerHTML += response.data.error + '<br>';
                        }else {
                            Object.entries(response.data).forEach(([key, value]) => {
                                document.querySelector('.alert-wrapper').classList.remove('hidden');
                                document.querySelector('.alert-text').innerHTML += value[0] + '<br>';
                            });
                        }
                    }
                })
                .catch(error => {
                    spinner.classList.add('hidden');
                    submitButton.disabled = false;
                    console.error(error);
                });
            });
        });
    }

    document.querySelector('form').addEventListener('submit', function (event) {
        event.preventDefault(); // Empêche la soumission normale du formulaire
        formSubmit();  // envoi du formulaire

        return false;
    });
}